// Remove protocol and www
export default function normalizeUrl(url) {
  return url && url.replace(/^(https?:\/\/)?(www\.)?/, '').replace(/\/$/, '');
}
